import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import PackageService from 'services/PackageService';

export const initialState = {
    package: {
        data: [],
        isLoading: false,
        error: false,
    },
    packageDetail: {
        data: [],
        isLoading: false,
        error: false,
    },
    addPackage: {
        data: [],
        isLoading: false,
        error: false,
    },
    packageEdit: {
        data: [],
        isLoading: false,
        error: false,
    },
    defaultCost: {
        data: [],
        isLoading: false,
        error: false,
    },
    addDefaultCost: {
        data: [],
        isLoading: false,
        error: false,
    },
    warrantyMaintenance: {
        data: [],
        isLoading: false,
        error: false,
    },
    warrantyMaintenanceDynamic: {
        data: [],
        isLoading: false,
        error: false,
    },
    assingPackageToChargePoint: {
        data: [],
        isLoading: false,
        error: false,
    },
    addExtendedMaintenance: {
        data: [],
        isLoading: false,
        error: false,
    }
}

export const fetchPackage = createAsyncThunk(
    'package/getPackages',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.getPackages(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchPackageDetail = createAsyncThunk(
    'package/getPackageDetail',
    async (params, { rejectWithValue }) => {
        try {
            const response = await PackageService.getPackageDetail(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const addPackage = createAsyncThunk(
    'package/addPackage',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.addPackage(data)
            return [response]
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const updatePackage = createAsyncThunk(
    'package/updatePackage',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.updatePackage(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const deletePackage = createAsyncThunk(
    'package/deletePackage',
    async (params, { rejectWithValue }) => {
        try {
            const response = await PackageService.deletePackage(params)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const addDefaultCost = createAsyncThunk(
    'package/addDefaultCost',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.addDefaultCost(data)
            return [response]
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const fetchDefaultCost = createAsyncThunk(
    'package/getDefaultCost',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.getDefaultCost(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const getWarrantyMaintenanceList = createAsyncThunk(
    'package/getWarrantyMaintenanceList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.getWarrantyMaintenanceList(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const getWarrantyMaintenanceListDynamic = createAsyncThunk(
    'package/getWarrantyMaintenanceListDynamic',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.getWarrantyMaintenanceListDynamic(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const assingPackageToChargePoint = createAsyncThunk(
    'package/assingPackageToChargePoint',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.assingPackageToChargePoint(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const addExtendedMaintenance = createAsyncThunk(
    'package/addExtendedMaintenance',
    async (data, { rejectWithValue }) => {
        try {
            const response = await PackageService.addExtendedMaintenance(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const packageSlice = createSlice({
    name: 'package',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchPackage.pending, (state, action) => {
                state.package.isLoading = true
            })
            .addCase(fetchPackage.rejected, (state, action) => {
                state.package.isLoading = false
                state.package.error = action.error.message
            })
            .addCase(fetchPackage.fulfilled, (state, action) => {
                state.package.isLoading = false
                state.package.error = false
                state.package.data = action.payload
            })

            .addCase(fetchPackageDetail.pending, (state, action) => {
                state.packageDetail.isLoading = true
            })
            .addCase(fetchPackageDetail.rejected, (state, action) => {
                state.packageDetail.error = action.error.message
            })
            .addCase(fetchPackageDetail.fulfilled, (state, action) => {
                state.packageDetail.isLoading = false
                state.packageDetail.error = false
                state.packageDetail.data = action.payload
            })

            .addCase(addPackage.pending, (state, action) => {
                state.addPackage.isLoading = true
            })
            .addCase(addPackage.rejected, (state, action) => {
                state.addPackage.isLoading = false
                state.addPackage.error = action.error.message
            })
            .addCase(addPackage.fulfilled, (state, action) => {
                state.addPackage.isLoading = false
                state.addPackage.error = false
                state.addPackage.success = true
            })

            .addCase(updatePackage.pending, (state, action) => {
                state.packageEdit.isLoading = true
            })
            .addCase(updatePackage.rejected, (state,action) => {
                state.packageEdit.isLoading = false
                state.packageEdit.error = action.error.message
            })
            .addCase(updatePackage.fulfilled, (state, action) => {
                state.packageEdit.isLoading = false
                state.packageEdit.error = false
                state.packageEdit.success = true
            })

            .addCase(deletePackage.fulfilled, (state, action) => {
                state.package.data = state.package.data.filter((pkg) => pkg.id !== action.payload);
            })

            .addCase(addDefaultCost.pending, (state, action) => {
                state.addDefaultCost.isLoading = true
            })
            .addCase(addDefaultCost.rejected, (state, action) => {
                state.addDefaultCost.isLoading = false
                state.addDefaultCost.error = action.error.message
            })
            .addCase(addDefaultCost.fulfilled, (state, action) => {
                state.addDefaultCost.isLoading = false
                state.addDefaultCost.error = false
                state.addDefaultCost.success = true
            })

            .addCase(fetchDefaultCost.pending, (state, action) => {
                state.defaultCost.isLoading = true
            })
            .addCase(fetchDefaultCost.rejected, (state, action) => {
                state.defaultCost.error = action.error.message
            })
            .addCase(fetchDefaultCost.fulfilled, (state, action) => {
                state.defaultCost.isLoading = false
                state.defaultCost.error = false
                state.defaultCost.data = action.payload
            })

            .addCase(getWarrantyMaintenanceList.pending, (state, action) => {
                state.warrantyMaintenance.isLoading = true
            })
            .addCase(getWarrantyMaintenanceList.rejected, (state, action) => {
                state.warrantyMaintenance.error = action.error.message
            })
            .addCase(getWarrantyMaintenanceList.fulfilled, (state, action) => {
                state.warrantyMaintenance.isLoading = false
                state.warrantyMaintenance.error = false
                state.warrantyMaintenance.data = action.payload
            })

            .addCase(getWarrantyMaintenanceListDynamic.pending, (state, action) => {
                state.warrantyMaintenanceDynamic.isLoading = true
            })
            .addCase(getWarrantyMaintenanceListDynamic.rejected, (state, action) => {
                state.warrantyMaintenanceDynamic.error = action.error.message
            })
            .addCase(getWarrantyMaintenanceListDynamic.fulfilled, (state, action) => {
                state.warrantyMaintenanceDynamic.isLoading = false
                state.warrantyMaintenanceDynamic.error = false
                state.warrantyMaintenanceDynamic.data = action.payload
            })

            .addCase(assingPackageToChargePoint.pending, (state, action) => {
                state.assingPackageToChargePoint.isLoading = true
            })
            .addCase(assingPackageToChargePoint.rejected, (state, action) => {
                state.assingPackageToChargePoint.isLoading = false
                state.assingPackageToChargePoint.error = action.error.message
            })
            .addCase(assingPackageToChargePoint.fulfilled, (state, action) => {
                state.assingPackageToChargePoint.isLoading = false
                state.assingPackageToChargePoint.error = false
                state.assingPackageToChargePoint.data = action.payload
                state.assingPackageToChargePoint.success = true
            })

            .addCase(addExtendedMaintenance.pending, (state, action) => {
                state.addExtendedMaintenance.isLoading = true
            })
            .addCase(addExtendedMaintenance.rejected, (state, action) => {
                state.addExtendedMaintenance.isLoading = false
                state.addExtendedMaintenance.error = action.error.message
            })
            .addCase(addExtendedMaintenance.fulfilled, (state, action) => {
                state.addExtendedMaintenance.isLoading = false
                state.addExtendedMaintenance.error = false
                state.addExtendedMaintenance.data = action.payload
            })
    },
})

export default packageSlice.reducer
